export const ConfigLayout = [
    {
        path: "/adjuvant-renal-cell-carcinoma/",
        layoutComp: "MultiBrandPageLayout"
    },
    // {
    //     path: "/",
    //     layoutComp: "MultiBrandPageLayout"
    // },
    // {
    //     path: "/site-map/",
    //     layoutComp: "MultiBrandPageLayout"
    // },
    // {
    //     path: "/contact-us/",
    //     layoutComp: "MultiBrandPageLayout"
    // },
    // {
    //     path: "/404/",
    //     layoutComp: "MultiBrandPageLayout"
    // },
]